<template>
  <div class="ch-component-warpper">
    <div class="ch-component ch-detail-component">
      <v-container fluid grid-list-lg class="ch-menu-wrapper ch-detail-page">
        <v-layout row wrap>
          <v-flex xs-12>
            <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
              <span class="ch-menu-btn-icon" v-show="navigationDrawer">
                <i class="fas fa-minus fa-fw"></i>
              </span>
              <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
                <i class="fas fa-plus fa-fw"></i>
              </span>
            </button> -->
            <span class="ch-component-title ml-2">DOMAIN Detail</span>
          </v-flex>
        </v-layout>
      </v-container>
      <domains-detail-info></domains-detail-info>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import DomainsDetailInfo from '@/components/admin/domains/DomainsDetailInfo';

  export default {
    data() {
      return {
        // NOTE: Full screen dialog
        dialog: false,
        navigationDrawer: true,
      };
    },
    methods: {
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      DomainsDetailInfo,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/DomainsDetail.vue